import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import apiInstanceV2 from '../../Apis/AxiosV2';
import { ASSETS_SERVICE, CHART_SERVICE } from '../EndPoints';

export const GetGraphByUserId = createAsyncThunk('graph/getGraphByUserId', async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .get(`${CHART_SERVICE.getGraphByUserId}${params}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
export const GetTemplates = createAsyncThunk('graph/getTemplates', async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2
        .get(CHART_SERVICE.getTemplates)

        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
export const GetAllChartsAvailable = createAsyncThunk(
    'graph/getAllChartsAvailable',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(CHART_SERVICE.getAllChartsAvailable)

            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const GetChartsAvailableByDashboardId = createAsyncThunk(
    'graph/getChartsAvailableByDashboardId ',
    async (dashboardId, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(CHART_SERVICE.getChartsAvailableByDashboardId(dashboardId))

            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const AddCharts = createAsyncThunk('graph/addCharts ', async ({ body }, { dispatch, getState }) => {
    let result = await apiInstanceV2
        .post(CHART_SERVICE.addCharts, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});
export const UpdateDashboardName = createAsyncThunk(
    'graph/updateDashboardName',
    async ({ body }, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(CHART_SERVICE.updateDashboardName, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        const code = result.code;
        return { data, status, code };
    },
);
export const UpdateChartPositions = createAsyncThunk(
    'graph/updateChartPositions',
    async ({ body }, { dispatch, getState }) => {
        const result = await apiInstance
            .put(CHART_SERVICE.updateChartPosition, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const CreateDashboard = createAsyncThunk(
    'graph/createDashboard',
    async ({ table, body }, { dispatch, getState }) => {
        let result = await apiInstance
            .post(CHART_SERVICE.createDashboard, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
